import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag & drop des items de menu, façon éditeur de menus WordPress.
// Chaque <ul data-menu-sortable-target="list"> (le niveau racine et la liste
// de sous-items de chaque item) devient une zone de tri. Comme toutes les
// listes partagent le même "group", un item peut être glissé d'une liste à
// l'autre pour changer de parent (l'imbriquer ou le sortir d'un sous-menu).
export default class extends Controller {
  static targets = ["list"]
  static values = { url: String }

  connect() {
    this.sortables = this.listTargets.map((list) =>
      Sortable.create(list, {
        group: "menu-items",
        animation: 150,
        handle: ".drag-handle",
        fallbackOnBody: true,
        swapThreshold: 0.65,
        emptyInsertThreshold: 20,
        onEnd: () => this.persist()
      })
    )
  }

  disconnect() {
    this.sortables?.forEach((s) => s.destroy())
  }

  persist() {
    const items = []

    this.listTargets.forEach((list) => {
      const parentId = list.dataset.parentId || null

      Array.from(list.children).forEach((li, index) => {
        if (!li.dataset.id) return
        items.push({ id: li.dataset.id, parent_id: parentId, position: index + 1 })
      })
    })

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ items })
    }).catch((error) => console.error("Échec de la sauvegarde de l'ordre du menu :", error))
  }
}
